import totalOrdersImg from '@/assets/home/dataEffect/orderData/modular_total_orders.png'
import validOrdersImg from '@/assets/home/dataEffect/orderData/modular_valid_order.png'
import salesOrdersImg from '@/assets/home/dataEffect/orderData/modular_sales_volume.png'
import chargebackOrdersImg from '@/assets/home/dataEffect/orderData/modular_chargeback_number.png'
import chargebackAmountImg from '@/assets/home/dataEffect/orderData/modular_chargeback_amount.png'
import modularTotalSalesVolumeImg from '@/assets/home/dataEffect/orderData/modular_total_sales_volume.png'
import { adPlatOptions } from '../../goodsInfo/taobao/config'
import moment from 'moment'

export const toPlatOptions = [
	{
		label: '淘宝',
		value: 10
	},
	{
		label: '京东',
		value: 16
	},
	{
		label: '拼多多',
		value: 7
	}
]

export const pushOptions = [
	{
		label: '已上报',
		value: 1
	}
]

export const synOrderStatusOptions = [
	{
		label: '下单',
		value: 1
	},
	{
		label: '支付',
		value: 2
	},
	{
		label: '支付定金',
		value: 3
	},
	{
		label: '完成订单',
		value: 7
	},
	{
		label: '已退款',
		value: 8
	},
	{
		label: '取消订单',
		value: 10
	},
	{
		label: '无效订单',
		value: 11
	},
	{
		label: '违规订单',
		value: 40
	}
]

export const renderList = [
	{
		label: '开始日期',
		key: 'startCreateDate',
		type: 'datePicker',
		placeholder: '请选择'
	},
	{
		label: '结束日期',
		key: 'endCreateDate',
		type: 'datePicker',
		placeholder: '请选择'
	},
	{
		label: '订单号',
		key: 'orderId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '商品ID',
		key: 'orderGoodsId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '订单状态',
		key: 'synOrderStatus',
		type: 'select',
		placeholder: '请选择',
		options: synOrderStatusOptions
	},
	{
		label: '电商平台',
		key: 'toPlat',
		type: 'select',
		placeholder: '请选择',
		options: toPlatOptions
	},
	{
		label: '引流平台',
		key: 'fromPlat',
		type: 'select',
		placeholder: '请选择',
		options: adPlatOptions
	},
	{
		label: '引流账号ID',
		key: 'advertiseId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '引流计划ID',
		key: 'planId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '是否上报',
		key: 'push',
		type: 'select',
		placeholder: '请选择',
		options: pushOptions
	},
]

export const renderMobileList = [
	{
		label: '选择日期',
		key: 'dates',
		type: 'rangePicker',
		placeholder: '请选择',
		maxInterval: 31,
		maxEndDate: new Date(moment(new Date()).format('YYYY-MM-DD')),
        minStartDate: new Date(moment(new Date()).subtract(2, 'year').format('YYYY-MM-DD'))
	},
	{
		label: '订单号',
		key: 'orderId',
		type: 'input',
		placeholder: '请输入',
	},
	{
		label: '商品ID',
		key: 'orderGoodsId',
		type: 'input',
		placeholder: '请输入',
		isRowEnd: true
	},
	{
		label: '订单状态',
		key: 'synOrderStatus',
		type: 'picker',
		placeholder: '请选择',
		valueKey: 'label',
		options: [{ label: '无', value: undefined }, ...synOrderStatusOptions]
	},
	{
		label: '电商平台',
		key: 'toPlat',
		type: 'picker',
		placeholder: '请选择',
		valueKey: 'label',
		options: [{ label: '无', value: undefined }, ...toPlatOptions],
		isRowEnd: true
	},
	{
		label: '引流平台',
		key: 'fromPlat',
		type: 'picker',
		placeholder: '请选择',
		valueKey: 'label',
		options: [{ label: '无', value: undefined }, ...adPlatOptions],
	},
	{
		label: '引流账号ID',
		key: 'advertiseId',
		type: 'input',
		placeholder: '请输入',
		isRowEnd: true
	},
	{
		label: '引流计划ID',
		key: 'planId',
		type: 'input',
		placeholder: '请输入',
	},
	{
		label: '是否上报',
		key: 'push',
		type: 'picker',
		placeholder: '请选择',
		valueKey: 'label',
		options: [{ label: '全部', value: undefined }, ...pushOptions],
		isRowEnd: true
	},
]

export const orderTotalRenderList = [
	{
		name: '总订单数',
		key: 'orderNum',
		img: totalOrdersImg
	},
	{
		name: 'GMV',
		key: 'orderValidTotalSalePrice',
		img: modularTotalSalesVolumeImg
	},
	{
		name: '有效订单数',
		key: 'orderValidNum',
		img: validOrdersImg,
		popoverText: "有效订单数：是支付定金、支付和完成订单三种状态的订单数汇总，如果检测到电商平台的订单状态发生了变化，这里的数据会同步更新。比如下单状态的订单发生了支付的操作，这里的数据会进行相应的增加；如果支付状态的订单发生了退款和取消订单的操作，这里的数据会进行相应的扣减。"
	},
	{
		name: '净销售额',
		key: 'orderValidEstimateCosPrice',
		img: salesOrdersImg,
		popoverText: "净销售额：有效订单的销售额汇总。"
	},
	{
		name: '退款订单数',
		key: 'orderReturnNum',
		img: chargebackOrdersImg
	},
	{
		name: '退款金额',
		key: 'orderReturnTotalPrice',
		img: chargebackAmountImg
	}
]



// WEBPACK FOOTER //
// ./src/pages/home/dataEffect/orderData/config.js